// Copyright (c) Microsoft Corporation. All rights reserved.
/**
 * Online status changed event.
 */
export class OnlineStatusChangedEvent extends Event {
    constructor() {
        super(OnlineStatusChangedEvent.type);
    }
}
OnlineStatusChangedEvent.type = 'onlineStatusChanged';
//# sourceMappingURL=OnlineStatusChangedEvent.js.map